<script setup lang="ts">
import KSwitchField from '@/components/fields/KSwitchField.vue';

const model = defineModel<{
  isCanSchedule?: boolean;
  isPayOnHold?: boolean;
  isInvoice?: boolean;
}>({
  default: () => ({
    isCanSchedule: false,
    isPayOnHold: false,
    isInvoice: false,
  }),
});
</script>

<template>
  <menu
    :class="$style.dispatchMoreFiltersSwitchesMenuList"
    data-testid="dispatchMoreFiltersSwitchesMenuList"
  >
    <li>
      <KSwitchField
        v-model="model.isCanSchedule"
        :class="$style.switchField"
        hide-details
        inset
        is-small
        is-label-first
        label="Can Schedule"
      />
    </li>
    <li>
      <KSwitchField
        v-model="model.isPayOnHold"
        :class="$style.switchField"
        hide-details
        inset
        is-small
        is-label-first
        label="Pay On Hold"
      />
    </li>
    <li>
      <KSwitchField
        v-model="model.isInvoice"
        :class="$style.switchField"
        hide-details
        inset
        is-small
        is-label-first
        label="Invoice"
      />
    </li>
  </menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dispatchMoreFiltersSwitchesMenuList {
  list-style: none;
  padding: 0;
  margin: 0;
}
  .switchField {
    :global {
      .v-selection-control {
      }
      .v-selection-control__wrapper {
        margin-right: 12px !important; /* TODO it depends on outside component */
      }
      .v-selection-control .v-label {
        width: 100%;
        margin-left: 13px !important; /* TODO it depends on outside component */
      }
    }
  }
</style>
